module.exports = __webpack_public_path__ + "img/icn-sportsbook.0b99bb05.png";